declare global {
  interface Window {
    dataLayer?: Record<string, any>[];
  }
}

export const dataLayerPush = (data: any) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(data);
  }
};
